import Vue from 'vue'
import VueRouter from 'vue-router'
import userService from '../services/user.service'

Vue.use(VueRouter)

const routes = [
  {
    path: '/administrador',
    name: 'Dashboard',
    component: () => import('../views/Dashboard'),
    meta: {
      log: true,
      admin: true,
      auth: true,
    }
  },

  {
    path: '/auth',
    name: 'autentificacion',
    component: () => import('../views/Autentificacion'),
    meta: {
      log: true,
      admin: true,
      auth: false
    }
  },

  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login'),
    beforeEnter: async (to, from, next) => {
      let tokenexp = await userService.tokenexp()

      if (tokenexp) {
        localStorage.clear(); //limpiar el localstorage
        next()
      }

      next();
    },
    meta: {
      log: false,
      admin: false,
      auth: false
    }
  },
  {
    path: '/magazine/:url',
    name: 'previewBlog',
    component: () => import('../views/blog/previewBlog'),
    meta: {
      log: false,
      admin: false,
      auth: false
    }
  },
  {
    path: '/previsualizacion/proyecto/:url',
    name: 'previewProject',
    component: () => import('../views/project/previewProject'),
    meta: {
      log: true,
      admin: true,
      auth: true
    }
  },

  {
    path: '/#LastProjects',
    name: 'LastProjects',
    component: () => import('../views/Home'),
    meta: {
      log: false,
      admin: false,
      auth: false
    }
  },

  {
    path: '/',
    name: 'home',
    component: () => import('../views/Home'),
    meta: {
      log: false,
      admin: false,
      auth: false
    }
  },

  {
    path: '/home/latest-proyects',
    name: 'latest-proyects',
    component: () => import('../views/Home'),
    meta: {
      log: false,
      admin: false,
      auth: false
    }
  },

  {
    path: '/home/about',
    name: 'about',
    component: () => import('../views/Home'),
    meta: {
      log: false,
      admin: false,
      auth: false
    }
  },
  {
    path: '/tienda-en-linea',
    name: 'Tienda en línea',
    component: () => import('../views/TiendaLanding'),
    meta: {
      log: false,
      admin: false,
      auth: false
    }
  },
  {
    path: '/desarrollo-web',
    name: 'Desarrollo web',
    component: () => import('../views/DesarrolloLanding'),
    meta: {
      log: false,
      admin: false,
      auth: false
    }
  },
  {
    path: '/naming-and-branding',
    name: 'Naming and branding',
    component: () => import('../views/NamingNBranding'),
    meta: {
      log: false,
      admin: false,
      auth: false
    }
  },
  {
    path: '/home/team',
    name: 'team',
    component: () => import('../views/Home'),
    meta: {
      log: false,
      admin: false,
      auth: false
    }
  },
  {
    path: '/home/stories',
    name: 'stories',
    component: () => import('../views/Home'),
    meta: {
      log: false,
      admin: false,
      auth: false
    }
  },
  {
    path: '/home/services',
    name: 'services',
    component: () => import('../views/Home'),
    meta: {
      log: false,
      admin: false,
      auth: false
    }
  },
  {
    path: '/home/partners',
    name: 'partners',
    component: () => import('../views/Home'),
    meta: {
      log: false,
      admin: false,
      auth: false
    }
  },
  {
    path: '/home/magazine',
    name: 'magazine',
    component: () => import('../views/Home'),
    meta: {
      log: false,
      admin: false,
      auth: false
    }
  },
  {
    path: '/home/contact-us',
    name: 'contact-us',
    component: () => import('../views/Home'),
    meta: {
      log: false,
      admin: false,
      auth: false
    }
  },

  /*{
    path: '/',
    name: 'home',
    component: () => import('../views/Proximamente'),
    meta :{
      log:false,
      admin : false,
      auth: false
    }
  },*/

  {
    path: '/politicas',
    name: 'Politicas',
    component: () => import('../views/politicas'),
    meta: {
      log: false,
      admin: false,
      auth: false
    }
  },

  {
    path: '/servicios',
    name: 'Servicios',
    component: () => import('../views/Servicios'),
    meta: {
      log: false,
      admin: false,
      auth: false
    }
  },

  {
    path: '/portafolio',
    name: 'Portafolio',
    component: () => import('../views/Portafolio'),
    meta: {
      log: false,
      admin: false,
      auth: false
    }
  },

  {
    path: '/brief',
    name: 'Brief',
    component: () => import('../views/Brief'),
    meta: {
      log: false,
      admin: false,
      auth: false
    }
  },

  {
    path: '/historias-de-exito',
    name: 'Historias de Exito',
    component: () => import('../views/HistoriasDeExito'),
    meta: {
      log: false,
      admin: false,
      auth: false
    }
  },

  {
    path: '/portafolio/:categoria',
    name: 'PortafolioCat',
    component: () => import('../views/Portafolio'),
    meta: {
      log: false,
      admin: false,
      auth: false
    }
  },

  {
    path: '/portafolio-post/por-kilo',
    name: 'Por Kilo portafolio white',
    component: () => import('../views/landing/porkilo'),
    meta: {
      log: false,
      admin: false,
      auth: false
    }
  },

  {
    path: '/portafolio-post/barrio-alegre',
    name: 'Barrio Alegre portafolio white',
    component: () => import('../views/landing/barrioAlegre'),
    meta: {
      log: false,
      admin: false,
      auth: false
    }
  },
  {
    path: '/portafolio-post/holy-o',
    name: 'Holy O portafolio white',
    component: () => import('../views/landing/holyO'),
    meta: {
      log: false,
      admin: false,
      auth: false
    }
  },

  {
    path: '/portafolio-post/:url',
    name: 'PortafolioPage white',
    component: () => import('../views/PortafolioContent'),
    meta: {
      log: false,
      admin: false,
      auth: false
    }
  },

  {
    path: '/development-post/pcvirgo',
    name: 'PC Virgo portafolio white',
    component: () => import('../views/Development/virgo'),
    meta: {
      log: false,
      admin: false,
      auth: false
    }
  },

  {
    path: '/development-post/alter',
    name: 'Alter portafolio white',
    component: () => import('../views/Development/alter'),
    meta: {
      log: false,
      admin: false,
      auth: false
    }
  },

  {
    path: '*',
    name: '404',
    component: () => import('../views/Error404'),
    meta: {
      log: false,
      admin: false,
      auth: false
    }
  },



  {
    path: '/proximamente',
    name: 'Proximamente',
    component: () => import('../views/Proximamente'),
    meta: {
      log: false,
      admin: false,
      auth: false
    }
  },



  {
    path: '/services/marketing',
    name: 'Marketing',
    component: () => import('../views/MktSection'),
    meta: {
      log: false,
      admin: false,
      auth: false
    }
  },



  {
    path: '/services/development',
    name: 'Development',
    component: () => import('../views/DevSection'),
    meta: {
      log: false,
      admin: false,
      auth: false
    }
  },



  {
    path: '/services/design',
    name: 'design',
    component: () => import('../views/DesSection'),
    meta: {
      log: false,
      admin: false,
      auth: false
    }
  },



  {
    path: '/tienda',
    name: 'Tienda',
    component: () => import('../views/Tienda'),
    meta: {
      log: false,
      admin: false,
      auth: false
    }
  },



  {
    path: '/magazine',
    name: 'BlogTest',
    component: () => import('../views/BlogTest'),
    meta: {
      log: false,
      admin: false,
      auth: false
    }
  },

  {
    path: '/about',
    name: 'About',
    component: () => import('../views/About'),
    meta: {
      log: false,
      admin: false,
      auth: false
    }
  },

  {
    path: '/lite-sites',
    name: 'LiteSites',
    component: () => import('../views/LiteSites'),
    meta: {
      log: false,
      admin: false,
      auth: false
    }
  },

  {
    path: '/services',
    name: 'Services',
    component: () => import('../views/Services'),
    meta: {
      log: false,
      admin: false,
      auth: false
    }
  },



]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
}


)



router.beforeEach(async (to, from, next) => {

  let meta_admin = to.matched.some(record => record.meta.admin);
  let meta_log = to.matched.some(record => record.meta.log);
  let meta_auth = to.matched.some(record => record.meta.auth);

  let tokenexp = await userService.tokenexp()
  let check = false //comprobar si esta logeado
  let admin = false;
  let type = ''


  if (tokenexp) { // ver que el token no este expirado.
    localStorage.clear(); //limpiar el localstorage
    next()
  }


  let response = await userService.getData()

  if (response.status == 'error') {
    localStorage.clear()
  }


  if (response.status == 'success') { //comprobar que sea un login valido.
    check = true;
    let isAdmin = userService.isAdmin(response.result);
    admin = isAdmin.admin
    type = isAdmin.type

  }

  let ath = await userService.getAth();


  // borrar el localstorage cada que vayamos a login.

  if (to.path === '/login' && check) {
    localStorage.clear()
    next()
  }


  if (meta_log) {
    if (check) {
      if (meta_admin) {
        if (admin) {

          if (meta_auth) {
            if (ath) {
              next();
            } else {
              localStorage.clear()
              next('/login')
            }
          } else { //...proximamente rutas que no requieran autentificacion
            next()
          }

        } else {
          localStorage.clear()
          next('/')
        }
      } else {
        if (admin) { //no requiere admin pero es admin
          next()
        } else {
          next()
        }
      }
    } else {
      next('/login')
    }


  } else {

    if (check) {
      if (admin) {
        next()
      } else {
        next();
      }
    } else {
      next();
    }

  }


});












export default router

